import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import IconButton from "@mui/material/IconButton";
import {
  RemoveCircleOutline as DeleteIcon,
  InsertDriveFile as FileIcon,
} from "@mui/icons-material";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import IOSwitch from "../../../components/Common/IOSCheckbox";
import { useIntl } from "react-intl";
import { FileInputButton } from "./FileInputButton";
import DocumentLayout from "../../../components/Layouts/DocumentLayout";
/**
 *
 * @param {*} param0
 */
const ImageUploadSection = ({ handleSetFieldValue, ...formProps }) => {
  const intl = useIntl();

  const handleFileInputChange = (fileList) => {
    // manually set the list of attachments for formik
    handleSetFieldValue("capture", fileList);
  };

  const handleFileRemove = (id) => {
    const sanitizedFiles = formProps.values.capture.filter(
      (file) => !(id === file.id),
    );
    // manually set the list of attachments for formik
    handleSetFieldValue("capture", sanitizedFiles);
  };

  return (
    <DocumentLayout>
      <Box component="section">
        <List dense>
          {formProps.values.capture.map((file) => (
            <ListItem key={file.id}>
              <ListItemIcon>
                <FileIcon />
              </ListItemIcon>
              <ListItemText>{file.name}</ListItemText>
              <ListItemSecondaryAction>
                <IconButton onClick={() => handleFileRemove(file.id)}>
                  <DeleteIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>

        <label htmlFor="capture">
          <FileInputButton onChange={handleFileInputChange} />
        </label>
      </Box>

      <Box component="section" sx={{ mb: 2 }}>
        <Box id="CaptureCanvas" sx={{ width: "100%" }} />
      </Box>

      {/* private */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Box>
          <Typography component="p">
            {intl.formatMessage({ id: "ticket.create.private.switch.label" })}
          </Typography>
          <FormHelperText>
            {intl.formatMessage({
              id: "ticket.create.private.switch.form_helper",
            })}
          </FormHelperText>
        </Box>
        <FormControl>
          <IOSwitch
            checked={formProps.values.private}
            onChange={(_event, value) => handleSetFieldValue("private", value)}
          />
        </FormControl>
      </Box>

      {/* anonym */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Box>
          <Typography component="p">
            {intl.formatMessage({ id: "ticket.create.anonymous.switch.label" })}
          </Typography>
          <FormHelperText>
            {intl.formatMessage({
              id: "ticket.create.anonymous.switch.form_helper",
            })}
          </FormHelperText>
        </Box>
        <FormControl>
          <IOSwitch
            onChange={(_event, value) =>
              handleSetFieldValue("anonymous", value)
            }
          />
        </FormControl>
      </Box>
    </DocumentLayout>
  );
};

export default ImageUploadSection;
